/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { getIEVersion } from './helper.mjs';
import '../../../_chunks/dep-56ceb7ce.mjs';
import '../../../_chunks/dep-2a2a0e63.mjs';
import '../../../_chunks/dep-c3626417.mjs';
import '../../../_chunks/dep-fc63c737.mjs';
import '../../../_chunks/dep-b011b919.mjs';
import '../../../_chunks/dep-ae1abe1d.mjs';
import '../../../_chunks/dep-7f2f03b4.mjs';
import '../../../_chunks/dep-eba62589.mjs';
import '../../../_chunks/dep-7d9e11c8.mjs';
import '../../../_chunks/dep-b9567f6a.mjs';
import '../../../_chunks/dep-654b4b01.mjs';
import '../../../_chunks/dep-a6022780.mjs';
import '../../../_chunks/dep-e00db566.mjs';
import '../../../_chunks/dep-fdde96c5.mjs';
import '../../../_chunks/dep-961339ce.mjs';

function getScrollbarWidthWithCSS() {
  var defaultScrollbarWidth = 6;
  if (typeof navigator === "undefined" || !navigator) return defaultScrollbarWidth;
  if (/(Chrome|Safari)/i.test(navigator.userAgent)) return defaultScrollbarWidth;
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  if (/Firefox/.test(navigator.userAgent)) {
    scrollbarWidth -= 4;
  }
  if (getIEVersion() <= 11) {
    scrollbarWidth = 12;
  }
  return scrollbarWidth;
}
function getScrollbarWidth() {
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

export { getScrollbarWidth, getScrollbarWidthWithCSS };
//# sourceMappingURL=getScrollbarWidth.mjs.map
